/** Server state. Everything from the API flows through TanStack Query. */

import { QueryClient } from '@tanstack/react-query'

import { ApiError } from '@/lib/api/client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Pages keep themselves current (asked for 2026-10-13): every query on screen
      // refetches each minute, and again when the window regains focus — which is what
      // brings the list up to date after a project was edited in its own window. Background
      // tabs do not poll. TanStack's structural sharing hands back the same objects when
      // nothing changed, so an open form is not reset by a refetch that found no change.
      refetchOnWindowFocus: true,
      refetchInterval: 60_000,
      retry: (failureCount, error) => {
        // Retrying a 4xx just repeats the same rejection. Only transient failures are
        // worth a second attempt.
        if (error instanceof ApiError && error.status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})

export const queryKeys = {
  me: ['me'] as const,
  projects: (filters?: Record<string, string | undefined>) => ['projects', filters ?? {}] as const,
  project: (id: string) => ['projects', id] as const,
  ranked: (filters?: Record<string, string | undefined>) =>
    ['projects', 'ranked', filters ?? {}] as const,
}
